import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=f66f37d0&scoped=true"
import script from "./uploads.vue?vue&type=script&lang=js"
export * from "./uploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f37d0",
  null
  
)

export default component.exports